module.exports = __webpack_public_path__ + "img/MasterCard.8fcb6a07.svg";